export default "__VITE_ASSET__dasH0n$U__"